const INITIAL_STATE = {
  siteParams: [],
};

export const siteParamsReducer = (state = INITIAL_STATE, action) => {
  return state;
};
